import AbortControllerWithParent from "../models/AbortControllerWithParent.model.ts";

const serverUrl = process.env.REACT_APP_BASE_URL
const serverApiKey = process.env.REACT_APP_API_KEY

export async function searchImage(email, file, opts = {})
{
    const {
        timeoutMs = 60000,
        signal,                  
    } = opts;

    const form = new FormData();
    form.append("file", file, file.name);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    const combinedSignal = signal 
            ? new AbortControllerWithParent(signal, controller).signal
            : controller.signal;

    const headers = {       
        "X-API-Key": serverApiKey,
        "X-User-Email":email
    };

    try {
        
        const res = await fetch(`${serverUrl}/images/search/by-image/media`,{
            body: form,
            method: "POST",            
            headers: headers,
            mode:'cors',            
            signal: combinedSignal,
            credentials: "same-origin",
        });
        const data = await res.json().catch(() => ({        
        }));

        if(!res.ok)
        {
            const message = data?.message || 
                            data?.detail ||
                            `Request failed with status ${res.status}`;
            const error = new Error(message);
            error.status = res.status;
            error.data = data;
            throw error;
        }
        
        return data;
    }
    finally
    {
        clearTimeout(timeoutId);
    }
}

export async function getLatestImages(email, opts = {})
{
    const {
        timeoutMs = 60000,
        signal,                  
    } = opts;

    const form = new FormData();    

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    const combinedSignal = signal 
            ? new AbortControllerWithParent(signal, controller).signal
            : controller.signal;

    const headers = {       
        "X-API-Key": serverApiKey,
        "X-User-Email":email
    };

    try {
        
        const res = await fetch(`${serverUrl}/images/search/latest`,{
            body: form,
            method: "POST",            
            headers: headers,
            mode:'cors',            
            signal: combinedSignal,
            credentials: "same-origin",
        });
        const data = await res.json().catch(() => ({        
        }));

        if(!res.ok)
        {
            const message = data?.message || 
                            data?.detail ||
                            `Request failed with status ${res.status}`;
            const error = new Error(message);
            error.status = res.status;
            error.data = data;
            throw error;
        }
        
        return data;
    }
    finally
    {
        clearTimeout(timeoutId);
    }
}